// extracted by mini-css-extract-plugin
export default {"color":"Proj2_color__viHnJ","middleTric":"Proj2_middleTric__6w-UV","bgCard":"Proj2_bgCard__J1DpC","linkPro":"Proj2_linkPro__6crF2","imgSizeProj":"Proj2_imgSizeProj__bphXA"};